module.exports = __webpack_public_path__ + "static/media/react-native.5252e1f1.png";